import { render, staticRenderFns } from "./TestDate.vue?vue&type=template&id=ba4e079c&scoped=true"
import script from "./TestDate.vue?vue&type=script&lang=js"
export * from "./TestDate.vue?vue&type=script&lang=js"
import style0 from "./TestDate.vue?vue&type=style&index=0&id=ba4e079c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4e079c",
  null
  
)

export default component.exports